/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { StaticQuery, graphql } from "gatsby"

import Header from "./header"
import "./layout.css"

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
          buildTime
        }
      }
    `}
    render={data => (
      <div className="layout__container">
        <Header siteTitle={data.site.siteMetadata.title} />
          <main>{children}</main>
          <footer className="footer__container">
            <div className="footer__content">
              <span className="footer__copyright">© {new Date().getFullYear()}, Ella Luhtasaari</span>
            </div>
          </footer>
      </div>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
